import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("rb_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api.me()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem("rb_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await api.login({ email, password });
    localStorage.setItem("rb_token", token);
    setUser(user);
    return user;
  };

  const register = async (body) => {
    const { token, user } = await api.register(body);
    localStorage.setItem("rb_token", token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("rb_token");
    setUser(false);
  };

  const homePath = (u = user) =>
    !u ? "/login" : u.role === "company" ? "/company" : u.role === "hotel_gm" ? "/hotel" : u.role === "sales" ? "/sales" : u.role === "front_desk" ? "/front-desk" : "/gm";

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, homePath }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
